// Nabız animasyonlu durum göstergesi. tone: "ok" | "warn" | "crit" | "idle"
export default function PulseDot({ tone = 'idle', animated = true }) {
  return <span className={`pulse ${tone} ${animated ? '' : 'is-static'}`} aria-hidden="true" />;
}
